
module.exports = (function () {
  'use strict';

  var init = function () {

    var lastScrollPos = 0;
    var header = document.getElementById('page-header');
    // sanity check if header does not exist
    if (header === null || header === undefined) return;

    window.onscroll = function() {
      var scrollTop = window.pageYOffset || document.body.scrollTop;

      // Check if scroll up or down
      if((scrollTop > lastScrollPos) && (scrollTop > header.offsetHeight)) {
        // Scroll down
        classie.add(header, 'hide-menu');
      }
      else {
        // Scroll up
        classie.remove(header, 'hide-menu');
      }
      lastScrollPos = scrollTop;
    };

  };

  return {
    init: init
  };

}());

